import alKonataPentristo from './al_konata_pentristo';
import alMonumentoDeZamenhof from './al_la_monumento_de_zamenhof_en_odessa';
import alLaJubileoDeLudmilaNovikova from './al_la_jubileo_de_ludmila_novikova';
import ankoraŭForasVintr from './ankoraŭ_foras_vintr';
import ĉiujesperoj from './ĉiuj_esperoj';
import avojVenkis from './avoj_venkis';
import disŝirasLaTerglobo from './disŝiras_la_terglobon_ŝtata_lim';
import infanajPoemetoj from './infanaj_poemetoj';
import kantoDeNeeŭropaHomoDeXXI from './kanto_de_neeŭropa_homo_de_XXI';
import kantojDeMalgrandaHomoDeXX from './kantoj_de_malgranda_homo_de_XX';
import kozliki from './kozliki';
import popolajŜtrofetoj from './popolaj_ŝtrofetoj';
import naturaEvolvo from './natura_evolvo';
import limerikoj from './limerikoj';
import niSimilasAlAliaRaso from './ni_similas_al_alia_raso';
import oraFiŝeto from './ora_fiŝeto';
import prekrasnajaMarkiza from './prekrasnaja_markiza';
import revoluciulo from './revoluciulo';
import sonetoPriKato from './soneto_pri_kato';
import tankaojKajHokku from './tankaoj_kaj_hokku';
import verdaKoloro from './verda_koloro';
import memoreAl from './memore_al';
import krimeajGekzametroj from './krimeaj_gekzametroj';
import aventurojDeIuMigrinto from './aventuroj_de_iu_migrinto';
import al_nepo from './al_nepo';
import jen_la_venk from './jen_la_venk';
import rimludoj from './rimludoj';
import pri_karmen from './pri_karmen';
import porinfanaj_strofetoj from './porinfanaj_strofetoj';
import kiel_nin_karesis from './kiel_nin_karesis';

const list = [
  alKonataPentristo, 
  infanajPoemetoj,
  kozliki,
  limerikoj,
  oraFiŝeto,
  tankaojKajHokku,
  disŝirasLaTerglobo,
  kantojDeMalgrandaHomoDeXX,
  krimeajGekzametroj,
  niSimilasAlAliaRaso,
  prekrasnajaMarkiza,
  sonetoPriKato,
  verdaKoloro,
  ankoraŭForasVintr,
  ĉiujesperoj,
  revoluciulo,
  naturaEvolvo,
  kantoDeNeeŭropaHomoDeXXI,
  alMonumentoDeZamenhof,
  alLaJubileoDeLudmilaNovikova,
  avojVenkis,
  popolajŜtrofetoj,
  memoreAl,
  aventurojDeIuMigrinto,
  al_nepo,
  jen_la_venk,
  rimludoj,
  pri_karmen,
  porinfanaj_strofetoj,
  kiel_nin_karesis
];

export default list;